export const GET_ORDER_HISTORY = '/historic-order'
